import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { issuesActions } from '@sonar-software/sonar-issues';
import { RestoreIcon } from '@ui/icons';
import { useAction } from '@hooks';
import React, { useCallback } from 'react';

export interface RestoreIssueButtonProps {
    sonarObjectId: number;
}

export const RestoreIssueButton: React.FC<RestoreIssueButtonProps> = ({ sonarObjectId }) => {
	const restoreIssueVisility = useAction(issuesActions.requestDeleteIssuesByIdVisibility);

	const handleRestoreClick = useCallback((e: React.MouseEvent) => {
		e.stopPropagation();

		restoreIssueVisility({ sonarObjectId });
	}, [ restoreIssueVisility, sonarObjectId ]);

	return (
		<Button
			icon={ <RestoreIcon /> }
			id={ `restore-issue-${sonarObjectId}` }
			onClick={ handleRestoreClick }
			type='default'>{ COPY_SPECIFIC.RESTORE }
		</Button>
	);
};
